import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import {ConfigService } from '../core/services/config.service'
import { WantedcreditService } from '../services/wantedcredit.service';
import { CreditofferService } from '../services/creditoffer.service';
import { LookupService } from '../services/lookup.service';
import { SearchComponent} from './search.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-wanted-credits',
  templateUrl: './wanted-credits.component.html',
  styleUrls: ['./wanted-credits.component.css']
})
export class WantedCreditsComponent implements OnInit {
  @ViewChild('ecoList') searchComponent: SearchComponent;
  @ViewChild('speciesList') searchSpeciesComponent: SearchComponent;
  @ViewChild('speciesList2') searchSpecies2Component: SearchComponent;
  wantedCredits: any = [];
  programs: any = [];
  enableCreditOffers = false;
  
  constructor(private lookupService: LookupService,
    private wantedCreditsService: WantedcreditService,
    private router: Router, private offerServie: CreditofferService, private configService: ConfigService) {
    
  }
  
  ngOnInit() {
    this.enableCreditOffers = this.configService.enableCreditOffers;
    if (this.enableCreditOffers) {
      this.loadPrograms();
    }
  }

  loadPrograms() {
    this.lookupService.Programs.subscribe(result => {
      this.programs = result;
      if (this.programs != null && this.programs != undefined) localStorage.setItem("prgmCount", this.programs.length);
    });
  }
  get enableOfferSumbission(): boolean {
    return this.programs != null && this.programs != undefined && this.programs.length >=1; 
  }
  get enableSubmitButton():boolean {
    return this.enableOfferSumbission && this.selectedCreditsCount > 0;
  }
  get selectedCreditsCount(): number {
    var selecteCount: number = 0;
    
    if (this.searchComponent != undefined) {
      var ecoCredits = this.searchComponent.getSelectedCredits();
      if (ecoCredits != null) selecteCount = ecoCredits.length;
    }

    if (this.searchSpeciesComponent != undefined) {
      var speciesCredits = this.searchSpeciesComponent.getSelectedCredits();
      if (speciesCredits != null) {
        var s1Count = speciesCredits.length;
        if (s1Count > 0) selecteCount = selecteCount + s1Count;

      }
    }
    
    if (this.searchSpecies2Component != undefined) {
      var speciesCredits2 = this.searchSpecies2Component.getSelectedCredits();
      if (speciesCredits2 != null) {
        var s2Count = speciesCredits2.length;
        if (s2Count > 0) selecteCount = selecteCount + s2Count;

      }
    }
    
    
    return selecteCount;
  }

  createOffer(option: string) {

    // var selectedCredits = this.searchComponent.
    var ecoCredits:any = [];
    var speciesCredits:any = [];
    var speciesCredits2:any = [];
    var creditIds: any = [];
    if (this.wantedCreditsService.selectedCredits == null) this.wantedCreditsService.selectedCredits = [];
        
  if (option == 'E') ecoCredits = this.searchComponent.getSelectedCredits();
  else if (option == 'S') speciesCredits = this.searchSpeciesComponent.getSelectedCredits();
  else speciesCredits2 = this.searchSpecies2Component.getSelectedCredits();
    
    if (ecoCredits != null && ecoCredits.length > 0) {
      ecoCredits.map((credit, index) => {
        if (this.wantedCreditsService.selectedCredits.findIndex(wc => wc.id == credit.id) < 0) {
          this.wantedCreditsService.selectedCredits.push(credit);
        }
      });
      
    }

    if (speciesCredits != null && speciesCredits.length > 0) {
      speciesCredits.map((credit, index) => {
        if (this.wantedCreditsService.selectedCredits.findIndex(wc => wc.id == credit.id) < 0) {
          this.wantedCreditsService.selectedCredits.push(credit);
        }
      });

    }

    this.wantedCreditsService.selectedCredits.map((item, index) => {
      creditIds.push(item.id);
    });
  
    localStorage.setItem('credits', JSON.stringify(creditIds));
    
    
    //Prepate the order - the API prepares the offer and returs a unique request ID
    const requestId = this.wantedCreditsService.requestId; 
    if (requestId != null && requestId != '') this.router.navigate(['/credit-offer']);
    else {
     if (this.programs == null || this.programs == undefined || this.programs.length <= 0) return;
     var program = this.programs[0];
     if (program == null) return; 
      this.offerServie.prepare(program.id, creditIds).subscribe((result) => {
        if (result != null && result.isValid) {
          this.wantedCreditsService.requestId = result.requestId;
          this.router.navigate(['/credit-offer']);
        }

      });
    } 
    
  }
  
}
